<template>
    <nav>
        <paginate
            :page-count="totalPage"
            :click-handler="goToNextPage"
            :prev-text="'&lsaquo;'"
            :next-text="'&rsaquo;'"
            :container-class="'pagination'"
        >
        </paginate>
    </nav>
</template>

<script>
import Paginate from 'vuejs-paginate';

export default {
    components: {
        Paginate,
    },
    name: 'CustomPagination',
    props: {
        activePage: {
            type: Number,
        },
        totalPage: {
            type: Number,
        },
    },
    methods: {
        goToNextPage(pageIndex) {
            if (!pageIndex) {
                pageIndex =
                    this.activePage === this.totalPage
                        ? this.activePage
                        : this.activePage + 1;
            }

            if (pageIndex === this.totalPage && this.activePage === pageIndex) {
                return false;
            }

            this.$emit('paginationHandle', {
                action: 'goToNextPage',
                pageIndex: pageIndex,
            });
        },
    },
};
</script>

<style scoped>

</style>
